import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  table: {
    marginTop: 24
  }
})
